import * as Yup from 'yup';

export const isObjectRequired = (message) => Yup.object().required(message).nullable();
export const isStringRequired = (message) => Yup.string().required(message).nullable();
export const isArrayOfRequired = ({ arrayContent, requiredMessage, minLength, aLeastMessage }) =>
  Yup.array().of(arrayContent).required(requiredMessage).min(minLength, aLeastMessage);

export const getWellsFromDataForm = (formData) => formData?.from[3]?.value?.imputationObject?.wells;

export const getIndexOfAccordion = (path) => parseInt(path.split('[')[1].split(']')[0], 10);

export const serviceCardValidationSchema = Yup.object().shape({
  service: isObjectRequired('Debe seleccionar un servicio'),
  probDate: isStringRequired('Seleccione una fecha probable'),
  needDate: isStringRequired('Seleccione una fecha de necesidad'),
  description: isStringRequired('Ingrese una descripción').min(
    1,
    'Debe ingresar al menos un caracter'
  )
});
// This is left commented in case at some point they want this validation back
// // Service and probDate must be unique
// .test(
//   'serviceDuplicate',
//   'Existe una solicitud de servicio con la misma fecha y servicio',
//   (item, data) => {
//     const accordionsArray =  data.from[2]?.value?.accordions;
//     const actualService = item.service
//     const indexOfActualService = getIndexOfAccordion(data.path)
//     const isTemplate = data.from[0]?.value?.isTemplate;

//     const filteredaccordionsArray = accordionsArray?.filter(
//       (_, index) => index !== indexOfActualService)
//     const isDateAndServiceDuplicated = filteredaccordionsArray
//       .some(
//         accordion => accordion.service?.service?.id === actualService?.id &&
//         formatFullDate(accordion.service?.probDate) === formatFullDate(item.probDate)
//       )
//     return !isDateAndServiceDuplicated
//   }
// );

const validationSchema = Yup.object().shape({
  currentStep: Yup.number(),
  ubication: Yup.object().shape({
    ubicationType: isObjectRequired('Debe seleccionar un tipo de ubicación'),
    uunn: isObjectRequired('Seleccione unidad de negocio'),
    ubication: isObjectRequired('Ingrese ubicación')
  }),
  imputationObject: Yup.object()
    .shape({
      wells: Yup.array()
        .of(
          Yup.object().shape({
            well: Yup.object()
              .test('wellDuplicate', 'El pozo ya fue agregado', (item, data) => {
                const wellsArray = getWellsFromDataForm(data);
                let error = true;
                const indexInput = Number(data.path.split('[')[1][0]);

                wellsArray?.forEach((well, i) => {
                  if (well?.well?.value === item?.value && i !== indexInput) {
                    error = false;
                  }
                });

                return error;
              })
              .nullable()
              .when('currentStep', {
                is: 1,
                then: Yup.object().required('Ingrese un pozo')
              }),
            event: Yup.lazy((value) => {
              if (!value) return Yup.mixed().notRequired();

              return Yup.object()
                .test('eventDiff', 'Ingrese el mismo evento para todos los pozos', (item, data) => {
                  const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
                  let error = true;
                  const indexInput = Number(data.path.split('[')[1][0]);

                  // The id belongs to the event
                  // map so that value is now wellEventId
                  // (which is specific to the Event–Well relationship)
                  // wellEventId and event id are always different
                  const eventDiff = wellsArray?.some(
                    (well, i) => well?.event?.id !== item?.id && i !== indexInput
                  );

                  if (item?.id) {
                    if (eventDiff) {
                      error = false;
                    }
                  }

                  return error;
                })
                .nullable()
                .required('Seleccione un evento');
            }),
            team: Yup.lazy((value) =>
              !value ? Yup.mixed().notRequired() : isObjectRequired('Seleccione un equipo')
            ),
            imputationType: isObjectRequired('Seleccione un tipo de imputación'),
            imputationObject: isObjectRequired('Seleccione un objeto de imputación'),
            state: Yup.string().nullable(),
            budget: Yup.string().nullable(),
            logisticCenter: Yup.string().nullable(),
            socCode: Yup.string().nullable(),
            soc: Yup.array().of(Yup.string()).nullable(),
            description: Yup.string().nullable(),
            warningBudget: Yup.bool(),
            add: Yup.bool(),
            editable: Yup.bool()
          })
        )
        .required('Debe completar este paso')
        .min(1, 'Ingrese al menos un pozo')
    })
    .when('currentStep', {
      is: 1,
      then: Yup.object().required('Debe completar este paso')
    }),
  // Cada acordion contiene servicios, proveedores, aprovadores y comunicadores
  // accordions => request => {step, service, provider, }
  accordions: Yup.array().of(
    Yup.object().shape({
      accordionStep: Yup.number(),
      service: serviceCardValidationSchema,
      provider: Yup.object().shape({
        providers: isArrayOfRequired({
          arrayContent: Yup.object().shape({
            provider: isObjectRequired('Ingrese proveedor'),
            contract: isObjectRequired('Seleccione un contrato'),
            businessUnit: isObjectRequired('Seleccione una unidad de negocio'),
            notificate: isObjectRequired('Seleccione notificador')
          }),
          requiredMessage: 'Ingrese proveedor',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un proveedor'
        })
      }),
      associatedUsers: Yup.object().shape({
        approvers: isArrayOfRequired({
          arrayContent: Yup.object(),
          requiredMessage: 'Ingrese aprobador',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un aprobador'
        }),
        inspectors: isArrayOfRequired({
          arrayContent: Yup.object(),
          requiredMessage: 'Ingrese inspector',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un inspector'
        }),
        receivers: isArrayOfRequired({
          arrayContent: Yup.object(),
          requiredMessage: 'Ingrese destinatario',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un destinatario'
        })
      })
    })
  )
});

export default validationSchema;
